import React, { useState } from 'react';
import { OtpInitiateForgotPassApi, VerifyOtpAndChangePassApi } from '../services/Api';
import { toast } from 'react-toastify';

const ForgotPass = () => {
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const showToast = (message) => {
    toast.success(message, { position: "top-right", });
  };

  const verifyOtp = async () => {
    setError('');
    setLoading(true);
    const response = await VerifyOtpAndChangePassApi({
      phoneNumber,
      newPassword,
      reEnterPassword: confirmPassword,
      otp,
    });

    if (!response) {
      showToast('Something went wrong!');
      setLoading(false);
      return;
    }

    console.log('VerifyOtpAndChangePassApi response:', response);
    if (response.status === 'success') {
      showToast('Otp verified successfully!');
      setLoading(false);
      setError('');
      window.history.back();
    } else {
      setError(response.message || 'Something went wrong!');
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {
    setError('');
    setLoading(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      setError('Please enter an email address');
      setLoading(false);
      return;
    }
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      setLoading(false);
      return;
    }

    const response = await OtpInitiateForgotPassApi(email);
    if (!response) {
      showToast('Something went wrong!');
      setLoading(false);
      return;
    }

    console.log('OtpInitiateForgotPassApi response:', response);
    if (response.status === 'success') {
      showToast('Otp sent successfully!');
      setOtpSent(true);
      setLoading(false);
      setError('');
    } else {
      setError(response.message || 'Something went wrong!');
      setLoading(false);
    }
  };

  return (
    <div className="forgotpass-container">
      <h3 className="otp-title">Forgot Password</h3>
      {otpSent ? (
        <div className="forgotpass-otp-container">
          <input
            type="number"
            className="forgotpass-input"
            placeholder="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            maxLength={10}
          />
          <input
            type="password"
            className="forgotpass-input"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            type="password"
            className="forgotpass-input"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <input
            type="number"
            className="forgotpass-input"
            placeholder="Enter Otp"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={6}
          />
          {loading ? (
            <div className="forgotpass-loader"></div>
          ) : (
            <button className="forgotpass-button" onClick={verifyOtp}>
              Change Password
            </button>
          )}
        </div>
      ) : (
        <div className="forgotpass-otp-container">
          <input
            type="email"
            className="forgotpass-input"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {loading ? (
            <div className="forgotpass-loader"></div>
          ) : (
            <button className="forgotpass-button" onClick={handleSendOtp}>
              Send Otp
            </button>
          )}
        </div>
      )}
      {error && <p className="forgotpass-error-text">{error}</p>}
    </div>
  );
};

export default ForgotPass;


